var _g, _g2, _use, _g3, _path, _path2, _use2, _use3, _use4, _g4, _path3, _g5, _ellipse, _g6, _g7, _path4, _path5, _path6, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _g8, _g9, _g10, _g11, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1200,
    height: 600,
    viewBox: "-7200 -3600 14400 7200",
    fill: "#046a38",
    stroke: "#000",
    strokeWidth: 7,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(300)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-24-12h48v24h-48z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffcd00",
    d: "M-24-3h48v3h-48zm21-9h3v24h-3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M-24 0h48v3h-48zM0-12h3v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-24-1h48v2h-48zm23-11h2v24h-2z"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 6,
    fill: "#d50032"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    id: "a",
    strokeWidth: 12,
    d: "m0-1600.6 56.3 173.2h182L91-1320.4l56.3 173.1L0-1254.3l-147.3 107 56.3-173.1-147.3-107h182z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(36)"
  })), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a",
    transform: "rotate(72)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    transform: "rotate(108)"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c",
    transform: "scale(-1)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(86)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 492,
    cy: -213,
    rx: 530,
    ry: 108
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 498,
    cy: -318,
    rx: 530,
    ry: 114
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 523,
    cy: -267,
    rx: 586,
    ry: 91
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9c4a00",
    d: "M439 868c-161 17-865 25-895 3s-75-115-75-120c92-4 52-53 99-79 46-27 112-9 132 23 20 33 4 65 29 66 26 0 526-24 710-11 30 2 53 29 53 59s-23 56-53 59z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "d",
    fill: "#ffcd00",
    d: "M-41 818c-1 70 101 50 103 108-3 61-172 4-174-109 7-112 172-167 174-103 2 53-101 35-103 104z"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 60
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 125
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d",
    x: 186
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(.85 1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(48.1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 317,
    cy: 154,
    rx: 68,
    ry: 58
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245,
    cy: 229,
    rx: 68,
    ry: 58
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 148,
    cy: 242,
    rx: 68,
    ry: 58
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(63.2)",
    cx: 251,
    cy: 100,
    rx: 73,
    ry: 57
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(57.7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 175,
    cy: 124,
    rx: 69,
    ry: 57
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 109,
    cy: 192,
    rx: 69,
    ry: 57
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9063cd",
    d: "M-177-632S-353-480-333-67c22 416 389 611 389 611h58V-632z"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(.85 1.8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(40.6)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 421,
    cy: 95,
    rx: 58,
    ry: 68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 337,
    cy: 151,
    rx: 58,
    ry: 68
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 255,
    cy: 132,
    rx: 58,
    ry: 68
  })), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(24.1)",
    cx: 305,
    cy: 161,
    rx: 58,
    ry: 73
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(29.9)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 450,
    cy: 70,
    rx: 57,
    ry: 69
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 79,
    rx: 57,
    ry: 69
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 279,
    cy: 87,
    rx: 57,
    ry: 69
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 192,
    cy: 106,
    rx: 57,
    ry: 69
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(66.5)",
    fill: "#d50032",
    strokeWidth: 4,
    cx: 149,
    cy: -149,
    rx: 456,
    ry: 148
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.25 .85)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 56,
    cy: -579,
    rx: 49,
    ry: 63
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 50,
    cy: -658,
    rx: 49,
    ry: 63
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -18,
    cy: -563,
    rx: 46,
    ry: 67
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -4,
    cy: -649,
    rx: 46,
    ry: 66
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -80,
    cy: -647,
    rx: 52,
    ry: 67
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15,
    cy: -758,
    rx: 49,
    ry: 63
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -50,
    cy: -746,
    rx: 46,
    ry: 66
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -148,
    cy: -643,
    rx: 46,
    ry: 67
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -132,
    cy: -693,
    rx: 46,
    ry: 66
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: -113,
    cy: -749,
    rx: 46,
    ry: 66
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(66.2)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 103,
    cy: -216,
    rx: 543,
    ry: 188
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 245,
    cy: -323,
    rx: 114,
    ry: 36
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M378 94c153 187 134 306 118 406L279 267V33z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M391 245c154 187 135 306 119 406L215 194v-307c23 60 23 171 176 358z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M396 367c157 183 140 303 126 404-50-115-78-188-236-372-157-184-83-317-74-386 25 59 27 170 184 354z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(65)",
    cx: 46,
    cy: -295,
    rx: 202,
    ry: 66
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(65.7)",
    cx: 112,
    cy: -197,
    rx: 166,
    ry: 58
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(66.8)",
    cx: 145,
    cy: -104,
    rx: 166,
    ry: 58
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(62)",
    cx: -45,
    cy: -265,
    rx: 127,
    ry: 46
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(65.6)",
    cx: -44,
    cy: -186,
    rx: 127,
    ry: 46
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M439 750a59 59 0 1 0 0 118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21-146a217 46 68 1 0 82-43"
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(65.6)",
    cx: -166,
    cy: -233,
    rx: 127,
    ry: 46
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(66.8)",
    cx: -167,
    cy: -145,
    rx: 127,
    ry: 46
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-30-299a155 33 59.7 1 0 54-41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1-349a140 32 59.8 1 0 65-21M117-323a214 46 59.3 1 0 75-56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48-388a161 34 62.4 1 0 53-45"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    fill: "#9063cd"
  }, /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M97-553c-29 30 1 84 27 106 31 26 201 207 321 56-96-2-276-228-348-162z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: -21,
    y: -89
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: -48,
    y: -174
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#e",
    x: -107,
    y: -271
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-219-917c61-46 173-59 260-15 73 36 194 181 285 216-64 11-103 1-144-18-81 58-110 67-192 79-115 16-210-14-244-73-34-57-19-147 35-189z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.4 .7)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#d50032",
    cx: -64,
    cy: -1181,
    rx: 38,
    ry: 44
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#000",
    cx: -66,
    cy: -1184,
    rx: 13,
    ry: 23,
    stroke: "none"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    fill: "#ffcd00"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(69.6)",
    cx: -747,
    cy: -11,
    rx: 45,
    ry: 73
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-206-786c5 23-12 55-50 66-38 16-67 52-84 111-58-134-21-191 41-205 53-17 85-15 93 28z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#000",
    cx: -262,
    cy: -756,
    r: 13,
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDm);
export default __webpack_public_path__ + "static/media/dm.dd0eb2caccf85e2a0df92bdb3718703d.svg";
export { ForwardRef as ReactComponent };